import {
  compose, not, either, isNil, isEmpty,
} from 'ramda';
import { V_TYPE_INTEGER, V_TYPE_NUMBER } from 'app-constants/variableTypes';

export const isNotEmpty = compose(not, either(
  isNil,
  isEmpty,
));

export const stateReducer = (prevState, newState) => ({ ...prevState, ...newState });

export const patternSelector = (type = '') => {
  switch (type) {
    case V_TYPE_INTEGER:
      return /^\d+$/;
    case V_TYPE_NUMBER:
      return /^[+-]?\d+(\.\d+)?$/;
    default:
      return null;
  }
};

export const checkValidations = (value, rules) => {
  let valid = true;
  if (rules.required && typeof value !== 'string') {
    valid = (String(value).trim() !== '') && valid;
  }
  if (rules.pattern) {
    valid = rules.pattern.test(value) && valid;
  }
  if (rules.notIncluded) {
    valid = !rules.notIncluded.includes(value) && valid;
  }
  if (rules.minLength) {
    valid = (rules.minLength <= value.length) && valid;
  }
  if (rules.arrayObject) {
    const { keys, validation: arrayValidation } = rules.arrayObject;
    if (keys) {
      value.forEach((item) => {
        keys.forEach((key) => {
          valid = checkValidations(item[key], arrayValidation) && valid;
        });
      });
    }
  }

  return valid;
};

/**
 * Deprecated, use `validateForm` instead.
 * This method returns `undefined` instead of false if the `valid` property is not present for
 * a form key, and an undefined return may mess up with a component's default props (it may
 * interpret the undefined as true depending on the configuration of the default props).
 */
export const getFormValidity = (formState) => {
  let formValidity = true;
  Object.keys(formState).forEach((inputKey) => {
    formValidity = formState[inputKey].valid && formValidity;
  });
  return formValidity;
};

export const validateForm = (formState) => Object.keys(formState)
  .reduce((isValid, inputKey) => {
    if (formState[inputKey].valid !== undefined) {
      return !!formState[inputKey].valid && isValid;
    }
    return isValid;
  }, true);

export const getFormTouched = (formState) => Object.keys(formState)
  .some((inputKey) => formState[inputKey].touched === true);

export const setFormUntouched = (formState, setState) => {
  Object.keys(formState).forEach((inputKey) => {
    const newInput = {
      ...formState[inputKey],
    };
    newInput.touched = false;
    setState({
      [inputKey]: newInput,
    });
  });
};
